import React, { useEffect, useRef } from 'react';

const TestimonialsWidget = () => {
  const widgetId = "44e7c6e3-c683-49dc-8f03-c2b3bd4c83c1";
  const initAttempted = useRef(false);
  const widgetContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (initAttempted.current) return;
    initAttempted.current = true;
    const initialize = () => {
      const container = widgetContainer.current;
      if (container) { container.style.display = 'block'; container.style.minHeight = '700px'; }
      const elfsightPlatform = (window as any).ELF || (window as any).ElfSight;
      try { if (elfsightPlatform?.initialize) elfsightPlatform.initialize(); } catch (e) {}
    };
    const attemptInit = () => { initialize(); setTimeout(initialize, 800); };
    if (document.readyState === 'complete') attemptInit();
    else window.addEventListener('load', attemptInit);
    return () => window.removeEventListener('load', attemptInit);
  }, []);

  return (
    <div className="w-full max-w-5xl mx-auto mb-16">
      <div className="bg-card rounded-3xl border border-border p-6 sm:p-8">
        <div ref={widgetContainer} className={`elfsight-app-${widgetId} w-full`} style={{ minHeight: '700px' }} />
      </div>
    </div>
  );
};

export default TestimonialsWidget;
